<ion-item lines="none">
  <ion-label>{{label}}</ion-label>
  <ion-text  [color]="isValid ? validColor : invalidColor">{{result}}</ion-text>
</ion-item>